import {Observable} from 'rxjs';
import {palipaliAPI} from '../provider/palipaliAPI';
import {IApiSingleResponseBase} from '../../types';
import {RestQueryParams} from '../base/queryParams';
import {IAnonymousJobDetailsOutput} from '../../model/jobListing';

export function getAnonymousJobAPI(authToken, payload: {id: string}): Observable<IApiSingleResponseBase<IAnonymousJobDetailsOutput>> {
    return palipaliAPI.get(`api/jobs/${payload.id}/anonymous`, new RestQueryParams());
}
